module.exports = __webpack_public_path__ + "img/392b0941247e9e3b64b883a840deac02.svg";